(function() {
  document.querySelectorAll('.bidding-container[data-gauge-id]').forEach(function(container) {
    var sendOfferBtn = container.querySelector('.gauge-send-offer-btn');
    var amountInput = container.querySelector('.gauge-amount-input');
    var minusBtn = container.querySelector('.bidding-button.left');
    var plusBtn = container.querySelector('.bidding-button.right');
    var needle = container.querySelector('.needle');
    var offerMessage = container.querySelector('.bidding-offer-messege span');

    // Read config from data attributes
    var ACCEPTANCE_PRICE = Number(container.dataset.acceptancePrice);
    var MAX_PRICE = Number(container.dataset.maxPrice);
    var MIN_PRICE = Number(container.dataset.minPrice);
    var STEP_AMOUNT = Number(container.dataset.stepAmount);
    var CONTACT_EMAIL = container.dataset.contactEmail;
    var CONTACT_PHONE = container.dataset.contactPhone;
    var FLOW_WEBHOOK_URL = container.dataset.webhookUrl;
    var PRODUCT_ID = container.dataset.productId;
    var VARIANT_ID = container.dataset.variantId;
    var PRODUCT_TITLE_LIQUID = container.dataset.productTitle;
    var PRODUCT_URL = container.dataset.productUrl;

    var emailSection = container.querySelector('.bidding-email-section');
    var emailInput = container.querySelector('.gauge-email-input');
    var claimDiscountBtn = container.querySelector('.gauge-claim-discount-btn');
    var statusEl = container.querySelector('.gauge-status');

    function isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    }

    function formatCurrency(amount) {
      return new Intl.NumberFormat('en-US').format(amount);
    }

    function getProductTitle() {
      var productTitle = document.querySelector('.product-title, h1, [itemprop="name"]');
      return productTitle ? productTitle.textContent.trim() : 'this product';
    }

    function calculateGaugePercent(offer) {
      if (offer <= MIN_PRICE) return 0;
      if (offer >= MAX_PRICE) return 100;
      return ((offer - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;
    }

    function getOfferMessage(gaugePercent) {
      if (gaugePercent >= 90) return 'Excellent!';
      if (gaugePercent >= 75) return 'Very Likely!';
      if (gaugePercent >= 60) return 'Likely!';
      if (gaugePercent >= 45) return 'Interesting!';
      if (gaugePercent >= 30) return 'Possible!';
      if (gaugePercent >= 15) return 'Unlikely!';
      return 'Too Low!';
    }

    var previousMessage = '';

    function updateGauge() {
      var offerAmount = parseInt(amountInput.value) || MIN_PRICE;
      var gaugePercent = calculateGaugePercent(offerAmount);
      var rotation = (gaugePercent / 100) * 180 - 90;
      needle.style.transform = 'translateX(-50%) rotate(' + rotation + 'deg)';

      if (offerAmount < ACCEPTANCE_PRICE && emailSection.classList.contains('visible')) {
        emailSection.classList.remove('visible');
        sendOfferBtn.style.display = '';
      }

      var newMessage = getOfferMessage(gaugePercent);
      if (newMessage !== previousMessage) {
        offerMessage.classList.remove('casino-spin');
        void offerMessage.offsetWidth;
        offerMessage.classList.add('casino-spin');
        offerMessage.textContent = newMessage;
        previousMessage = newMessage;
      }
    }

    minusBtn.addEventListener('click', function() {
      var currentValue = parseInt(amountInput.value) || MIN_PRICE;
      var newValue = Math.max(MIN_PRICE, currentValue - STEP_AMOUNT);
      amountInput.value = newValue;
      updateGauge();
    });

    plusBtn.addEventListener('click', function() {
      var currentValue = parseInt(amountInput.value) || MIN_PRICE;
      var newValue = Math.min(MAX_PRICE, currentValue + STEP_AMOUNT);
      amountInput.value = newValue;
      updateGauge();
    });

    amountInput.addEventListener('blur', function() {
      var value = parseInt(amountInput.value) || MIN_PRICE;
      if (value < MIN_PRICE) value = MIN_PRICE;
      if (value > MAX_PRICE) value = MAX_PRICE;
      amountInput.value = value;
      updateGauge();
    });

    function showStatus(type, message) {
      statusEl.className = 'bidding-status gauge-status visible ' + type;
      statusEl.textContent = message;
    }

    function hideStatus() {
      statusEl.className = 'bidding-status gauge-status';
      statusEl.textContent = '';
    }

    function sendManualOffer(offerAmount) {
      var productTitle = getProductTitle();
      var message = 'Hi, I\'m interested in buying ' + productTitle + '. I\'d like to offer $' + formatCurrency(offerAmount) + '.\n\n' + PRODUCT_URL;

      if (isMobile() && CONTACT_PHONE) {
        var smsBody = encodeURIComponent(message);
        window.location.href = 'sms:' + CONTACT_PHONE + (/iPhone|iPad|iPod/i.test(navigator.userAgent) ? '&' : '?') + 'body=' + smsBody;
      } else {
        var emailSubject = encodeURIComponent('Offer for ' + productTitle);
        var emailBody = encodeURIComponent(message);
        window.location.href = 'mailto:' + CONTACT_EMAIL + '?subject=' + emailSubject + '&body=' + emailBody;
      }
    }

    sendOfferBtn.addEventListener('click', function() {
      var offerAmount = parseInt(amountInput.value) || MIN_PRICE;
      hideStatus();

      if (offerAmount < ACCEPTANCE_PRICE * 0.4) {
        return;
      }

      if (offerAmount >= ACCEPTANCE_PRICE && FLOW_WEBHOOK_URL) {
        emailSection.classList.add('visible');
        sendOfferBtn.style.display = 'none';
        emailInput.focus();
      } else {
        sendManualOffer(offerAmount);
      }
    });

    claimDiscountBtn.addEventListener('click', function() {
      var offerAmount = parseInt(amountInput.value) || MIN_PRICE;
      var customerEmail = emailInput.value.trim();

      if (!customerEmail || !emailInput.checkValidity()) {
        showStatus('error', 'Please enter a valid email address.');
        return;
      }

      claimDiscountBtn.disabled = true;
      sendOfferBtn.disabled = true;
      showStatus('loading', 'Submitting your offer...');

      var payload = {
        product_id: PRODUCT_ID,
        variant_id: VARIANT_ID,
        product_title: PRODUCT_TITLE_LIQUID,
        offer_amount: offerAmount,
        product_price: MAX_PRICE,
        accepted_price: ACCEPTANCE_PRICE,
        customer_email: customerEmail
      };

      fetch(FLOW_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(response) {
        if (response.status === 422) {
          showStatus('error', 'That offer is a bit low for instant approval. Sending it to our team instead...');
          setTimeout(function() { sendManualOffer(offerAmount); }, 1500);
          return;
        }
        if (!response.ok) throw new Error('Request failed');
        showStatus('success', "We'll reach out via email shortly.");
        sendOfferBtn.style.display = 'none';
      })
      .catch(function() {
        showStatus('error', 'Something went wrong. Sending your offer via email instead...');
        setTimeout(function() {
          sendManualOffer(offerAmount);
        }, 1500);
      })
      .finally(function() {
        claimDiscountBtn.disabled = false;
        sendOfferBtn.disabled = false;
      });
    });

    amountInput.addEventListener('input', function() {
      var value = parseInt(amountInput.value) || MIN_PRICE;
      if (value < MIN_PRICE) value = MIN_PRICE;
      if (value > MAX_PRICE) value = MAX_PRICE;
      amountInput.value = value;
      updateGauge();
    });

    amountInput.value = Number(container.dataset.startingOffer) || MAX_PRICE;
    updateGauge();
  });
})();
